import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { dgWithReducer } from 'dg-utils';
import { r as reducer } from './reducer-d2bd51aa.js';
import { c as createPost, h as uploadImage, b as setPostLoading } from './post.actions-dcd472e5.js';
import { B as BlogForm } from './blogForm.component-cddf3030.js';

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NewPostPage = /*#__PURE__*/function (_Component) {
  _inherits(NewPostPage, _Component);

  var _super = _createSuper$1(NewPostPage);

  function NewPostPage() {
    _classCallCheck(this, NewPostPage);

    return _super.apply(this, arguments);
  }

  _createClass(NewPostPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$post;

      return /*#__PURE__*/React.createElement("div", {
        className: "blogEditor"
      }, this.props.post && this.props.post.title !== '' ? /*#__PURE__*/React.createElement(BlogForm, {
        handleSelectedFile: this.props.handleSelectedFile,
        onSubmit: this.props.onSubmit,
        uploadImage: this.props.uploadImage,
        blog: this.props.blog,
        tags: (_this$props$post = this.props.post) === null || _this$props$post === void 0 ? void 0 : _this$props$post.tags,
        headerImageAccept: this.props.headerImageAccept
      }) : this.props.noPostComponent ? this.props.noPostComponent : /*#__PURE__*/React.createElement("h1", null, "No Post Selected"));
    }
  }]);

  return NewPostPage;
}(Component);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AdminPostNew = /*#__PURE__*/function (_Component) {
  _inherits(AdminPostNew, _Component);

  var _super = _createSuper(AdminPostNew);

  function AdminPostNew(props) {
    var _this;

    _classCallCheck(this, AdminPostNew);

    _this = _super.call(this, props);
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AdminPostNew, [{
    key: "onSubmit",
    value: function onSubmit(data) {
      var _this2 = this;

      console.log(_objectSpread({}, data));
      this.props.setPostLoading(true);
      console.log("Form Submit :: New");
      console.log(_objectSpread({}, data));
      var form = new FormData();

      if (data.header_image && data.header_image.length > 0) {
        for (var index = 0; index < data.header_image.length; index++) {
          form.append("header_image", data.header_image[index]);
        }

        delete data.header_image;
      }

      console.log(_objectSpread({}, data));
      form.append("post_details", JSON.stringify(data));
      this.props.createPost(form).then(function (res) {
        Swal.fire("Success!", "".concat(res.message), "success");
        window.scrollTo(0, 0);

        _this2.props.history.push("/admin/posts");
      })["catch"](function (res) {
        Swal.fire("Couldn't save Post!", "".concat(res.message), "error");
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "redux-blogs-container"
      }, this.props.sidebar ? this.props.sidebar : "", /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement("div", {
        className: "redux-blogs-header-container"
      }, /*#__PURE__*/React.createElement("h1", null, "Admin New Post")), /*#__PURE__*/React.createElement(NewPostPage, {
        onSubmit: this.onSubmit,
        post: this.props.posts.currentPost,
        uploadImage: this.props.uploadImage,
        blog: this.props.posts,
        noPostComponent: this.props.noPostComponent
      })));
    }
  }]);

  return AdminPostNew;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    posts: state.blogs
  };
};

var adminNewPost = connect(mapStateToProps, {
  createPost: createPost,
  uploadImage: uploadImage,
  setPostLoading: setPostLoading
})(dgWithReducer(AdminPostNew, "blogs", reducer));

export { NewPostPage as N, adminNewPost as a };
